import { switchUserTournament } from 'modules/auth/store/actions';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useIsAdmin } from 'shared/hooks/use-is-admin';
import { AppDispatch, history } from 'store/store';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { selectOrganizerById } from '../../../store/selectors';
import OrganizerInfo from '../../components/organizer-info';
import Balance from '../../elements/balance/balance';
import { MainBlock } from './styles';

function OrganizerCard() {
  const dispatch = useDispatch<AppDispatch>();
  const { info } = useOrganizer();
  const pageOrganizerView = useMatch(`${Pages.ORGANIZERS.VIEW}`);
  const organizer = useSelector(selectOrganizerById(+(pageOrganizerView?.params?.id ?? -1)));
  const { setHeaderContent } = useMainLayout();

  const isCurrentOrganizer = useMemo(() => {
    return info?.id === organizer?.id;
  }, [info, organizer]);

  const breadcrumbs = useMemo(() => {
    const items = [{ label: 'Организаторы', to: Pages.ORGANIZERS.INDEX }];

    const { name, id } = organizer ?? {};
    if (name && id) {
      items.push({ label: name, to: `${Pages.ORGANIZERS.builders.view(id)}` });
    }

    return items;
  }, [organizer]);

  const handleChangeTournament = useCallback(() => {
    if (organizer?.id) {
      dispatch(switchUserTournament(organizer.id));
    } else {
      toast.error('Невозможно переключиться, обновите страницу');
      console.error('organizer id is undefined', { organizer });
    }
  }, [organizer, dispatch]);

  useEffect(() => {
    setHeaderContent(<UDBreadcrumbs breadcrumbs={breadcrumbs} />);
    return () => setHeaderContent(null);
  }, [breadcrumbs, setHeaderContent]);

  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <MainBlock>
        <div className="d-flex align-items-center justify-content-between container flex-row py-3">
          <div className="d-flex align-items-center gap-6">
            <UDText type="headline">Информация об организаторе</UDText>
            <UDButton
              onClick={() => history.push(Pages.ORGANIZERS.INDEX)}
              className={'flex-center'}
              variant={'primary'}
              style={{ height: 36 }}
            >
              Вернуться к списку
            </UDButton>
            {!isCurrentOrganizer && (
              <UDButton onClick={handleChangeTournament} className={'flex-center'} variant={'primary'} style={{ height: 36 }}>
                Переключиться на {organizer?.name}
              </UDButton>
            )}
          </div>

          <Balance organizer={organizer} />
        </div>
        <div className="d-flex align-items-center bb-1 container" />
        <div className="container py-6">
          <OrganizerInfo />
        </div>
      </MainBlock>
    </>
  );
}

export default OrganizerCard;
